module.exports = __webpack_public_path__ + "static/media/crezona-coming-soon.d8baa2be.png";